module.exports = __webpack_public_path__ + "img/logout-reverse.6b989b4a.svg";